import React from "react";
import "./SettingsDrawer.css";
import { useNavigate } from "react-router-dom";

const menuItems = [
  "City",
  "Client Stages",
  "Country",
  "Pipeline Stages",
  "Deal Stages",
  "Deals Pipeline",
  "Deal Lost Reasons",
  "Drop Reasons",
  "Follow-up Type",
  "Source",
  "Lead Stages",
  "Organization",
  "Preferences",
  "Priority",
  "Product Brands"
];

export default function SettingsDrawer({ open, onClose }) {
    const navigate = useNavigate();
  return (
    <>
      <div
        className={`drawer-overlay ${open ? "show" : ""}`}
        onClick={onClose}
      />

      <div className={`settings-drawer ${open ? "open" : ""}`}>
        <div className="drawer-header">
          <h3>⚙ Settings</h3>

          <button onClick={onClose}>✕</button>
        </div>

        <div className="drawer-search">
          <input
            type="text"
            placeholder="Search..."
          />
        </div>

        <div className="drawer-menu">
          {menuItems.map((item) => (
  <div
    key={item}
    className="drawer-item"
    onClick={() => {
       if (item === "Pipeline Stages") {
  navigate("/settings/pipeline-stages");
  onClose();
  return;
} 
      if (item === "Deal Stages") {
        navigate("/settings/deal-stages");
        onClose();
      }
      

      if (item === "Lead Stages") {
    navigate("/settings/lead-stages");
    onClose();
}
      if (item === "Drop Reasons") {
    navigate("/settings/drop-reasons");
    onClose();
}
if (item === "Deal Lost Reasons") {
    navigate("/settings/deal-lost-reasons");
    onClose();
}

if (item === "Source") {
    navigate("/settings/sources");
    onClose();
}
    }}
  >
    <span className="drawer-icon">⚙</span>
    {item}
  </div>
))}
        </div>
      </div>
    </>
  );
}